export default "__VITE_ASSET__BzplKv4b__"